//-------------------------------------------------------------------------------------------------- Imports
import { Col, Row, Space } from "antd";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { Key, ReactNode, useCallback, useEffect, useState } from "react";
import { getMeganFaqs } from "../../methods/Methods";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import Loading from "../../components/Loading";
import ListAccordion from "../../components/ListAccordion";
import _ from "lodash";
import ListItemAccordionFaq from "./components/ListItemAccordionFaq";
import InfoCardComponent from "../../components/InfoCardComponent";
import { StyleSheet } from "../../StyleSheet";

interface ListAccordionItem {
    key: Key;
    title: string;
    children: ReactNode;
};

//-------------------------------------------------------------------------------------------------- View
const FrequentlyAskedQuestions = () => {
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [faqList, setFaqList] = useState<ListAccordionItem[]>([]);
    const [hasError, setHasError] = useState(false);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getMeganQuestionList = useCallback(async () => {
        setIsLoading(true);

        await getMeganFaqs(idCliente)
            .then((response) => {
                if (response && response.data && response.data.data) {
                    let faqTypes = response.data.data.map(({ megan_faqs, type }, index) => {
                        let faq = megan_faqs.map((elem, i) => {
                            return {
                                key: i,
                                question: elem.question,
                                prompt: elem.prompt,
                            };
                        });
                        let faqTitle = "";
                        switch (type) {
                            case "television":
                                faqTitle = "Televisión"
                                break;
                            case "internet":
                                faqTitle = "Internet"
                                break;
                            case "telefonia":
                                faqTitle = "Telefonía Fija"
                                break;
                            case "movil":
                                faqTitle = "Telefonía Movil"
                                break;
                            case "general":
                                faqTitle = "General"
                                break;
                        }
                        return {
                            key: index,
                            title: faqTitle,
                            children:
                                (
                                    <Space direction="vertical" style={{ width: "100%" }}>
                                        <ListItemAccordionFaq idCliente={idCliente} items={faq} />
                                    </Space>
                                ),
                        };
                    });
                    setFaqList(faqTypes);
                } else {
                    setHasError(true);
                    setMessage("No hay información para mostrar.");
                }
            })
            .catch(() => {
                setHasError(true);
                setMessage("Hubo un error al procesar su solicitud. \nIntente más tarde.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [idCliente]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (idCliente) {
            getMeganQuestionList();
        }
    }, [idCliente, getMeganQuestionList]);

    return (
        <>
            {
                isLoading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Preguntas Frecuentes"} needReturn={true} navigateTo={"/technical-support"}>
                        <div style={{ marginTop: 20 }}>
                            {
                                hasError ?
                                    <InfoCardComponent title="¡Estimado usuario!" description={message} />
                                    :
                                    !_.isEmpty(faqList) ?
                                        <Row style={styles.rowPrincipal}>
                                            <Col xs={16} xl={14} style={{ paddingLeft: 10 }}>
                                                <ListAccordion items={faqList} />
                                            </Col>
                                        </Row>
                                        : null
                            }
                        </div>
                    </SubDefaultLayout>
            }
        </>
    );
};

const styles = StyleSheet.create({
    rowPrincipal: {
        marginTop: 10,
        display: 'flex',
        justifyContent: 'center',
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default FrequentlyAskedQuestions;
